import { EditableImg, EditableText } from '@smartfire/components'
import { defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine'
import React from 'react'
import Button from '../../button/block'
import style from './block.module.scss'
import { useTranslation } from 'react-i18next'

const Inspector = React.lazy(() => import('./Inspector'))

const Block = () => {
    const { t } = useTranslation()
    useInspectorControl(Inspector)
    const { isEditing } = useEditor()

    return isEditing ? (
        <div className={style.admin}>
            <div className={style.column1}>
                <EditableImg smartProp="image" />
            </div>
            <div className={style.column2}>
                <EditableText
                    className={style.title}
                    smartProp="title"
                    placeholder="Titre"
                    tagName="span"
                />
                <EditableText smartProp="description" placeholder="Description..." />
                <Button
                    text={t('DÉCOUVRIR')}
                    link={undefined}
                    aspect="contained"
                    color={style.darkBlue}
                    colorHover={style.blue}
                    inspector={false}
                />
            </div>
        </div>
    ) : (
        <div className={style.front}>
            <EditableText
                className={style.title}
                smartProp="title"
                placeholder="Titre"
                tagName="span"
            />
            <EditableText
                className={style.description}
                smartProp="description"
                placeholder="Description..."
            />
        </div>
    )
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.image,
        title: smartProps.string,
        description: smartProps.string.withDefault(
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque varius justo et tortor pellentesque pharetra.',
        ),
        link: smartProps.string.withDefault('/'),
    },
    setup: {
        title: 'Home Hero - Card',
        parent: ['smartfire/home-hero'],
    },
})
